const WIDTHS = [220, 451, 681, 911, 1142, 1372];

export const getStaticBlockWidthFromColumns = (
  columns: 1 | 2 | 3 | 4 | 5 | 6
) => {
  return WIDTHS[columns - 1];
};
